import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Validation from "../../../../../utils/validation";
import AccountName from "../../../../_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../_utils/AccountCreationComponents/ContactDetails";
import CommonLayout from "../../../../_utils/CommonLayout";
import "./index.css";

const BeneAccountStepContact = (props) => {
  const emailRegex = Validation.emailRegex;
  const [labels, setLabels] = useState([]);
  const [customErrors, setCustomErrors] = useState({});
  const [emailValidation, setEmailValidation] = useState(false);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);

  const handleRadioBtn = (event) => {
    props?.setSelectedValue(event.target.value);
    if (event.target.value === "legalname") {
      handleUpdateLegalName();
    } else if (event.target.value === "username") {
      handleUpdateUsername();
    }
  };

  const { verifyPAN } = useSelector((state) => state.verify);

  const handleUpdateLegalName = () => {
    const beneficiaryData = verifyPAN?.pan_details?.full_name;
    props?.setPayload((prevPayload) => ({
      ...prevPayload,
      account_name: beneficiaryData,
    }));
    props?.setAccountNameValidation(true);
  };

  const handleUpdateUsername = () => {
    props?.setAccountNameValidation(true);
    props.setPayload((prev) => ({
      ...prev,
      account_name: props.payload.userName,
    }));
  };

  const modifyValue = (type, value) => {
    if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);

    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name !== "account_name") {
      value = modifyValue(name, value?.replace(/\s/g, ""));
    } else {
      value = value.replace(/\s+/g, " ");
    }

    if (props.payload) {
      if (allowedValue(name, value)) {
        validateAndRecordError(name, value);
        const newObj = { ...props.payload, [name]: value };
        props?.setPayload(newObj);
      }
      if (
        props?.payload?.contact_no &&
        (props?.payload?.contact_no?.length === 0 ||
          props?.payload?.contact_no?.length < 10)
      ) {
        setContactNumberValidation(false);
      }
      if (props?.payload?.email_id && props?.payload?.email_id?.length === 0) {
        setEmailValidation(false);
      }
      if (name === "account_name") {
        if (value.trim().length > 0) {
          if (value === verifyPAN?.pan_details?.full_name) {
            props?.setSelectedValue("legalname");
          } else if (value === props.payload.userName) {
            props?.setSelectedValue("username");
          } else {
            props?.setSelectedValue("customname");
          }
          props?.setAccountNameValidation(true);
        } else {
          props?.setAccountNameValidation(false);
        }
      }
    }
  };

  useMemo(() => {
    if (customErrors["contact_no"]) {
      setContactNumberValidation(false);
    }
    if (
      !customErrors["contact_no"] &&
      props.payload.contact_no?.length === 10
    ) {
      setContactNumberValidation(true);
    }
    if (customErrors["email_id"]) {
      setEmailValidation(false);
    }
    if (
      !customErrors["email_id"] &&
      props.payload.email_id?.length > 0 &&
      emailRegex.test(props.payload.email_id)
    ) {
      setEmailValidation(true);
    }
  }, [contactNumberValidation, emailValidation, customErrors, props.payload]);

  useEffect(() => {
    if (
      emailValidation &&
      contactNumberValidation &&
      props?.accountNameValidation
    ) {
      props.setIsNextButtonEnabled(false);
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
    } else if (props?.activeStep === 2) {
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
      props.setIsNextButtonEnabled(true);
    }
  }, [
    emailValidation,
    contactNumberValidation,
    props?.accountNameValidation,
    props?.activeStep,
  ]);

  const handleDivBtn = (value) => {
    props?.setSelectedValue(value);
    if (value === "legalname") {
      handleUpdateLegalName();
    } else if (value === "username") {
      handleUpdateUsername();
    }
  };
  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, []);

  // useEffect(() => {
  //   if (labelpopup) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }

  //   return () => {
  //     document.body.style.overflow = "auto";
  //   };
  // }, [labelpopup]);

  return (
    <>
      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto">
        <CommonLayout>
          <AccountName
            handleChange={handleChange}
            accountNameValidation={props?.accountNameValidation}
            accountName={props.payload.account_name}
            selectedValue={props?.selectedValue}
            handleDivBtn={handleDivBtn}
            handleRadioBtn={handleRadioBtn}
            selectedRadioValue={props?.selectedValue}
            legalName={props?.payload?.legalName}
            type={props.flow === "reimbursement" ? "user" : ""}
            userName={props.payload.userName}
          />

          <div className="Qlg:pb-padding-base pb-padding-md">
            <ContactDetails
              handleChange={handleChange}
              contactNumberValidation={contactNumberValidation}
              emailValidation={emailValidation}
              contactNumber={props.payload.contact_no}
              emailId={props.payload.email_id}
              selectedValue={props?.selectedValue}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneAccountStepContact;
